import { getChatInfo } from '@/api/chat'
//时间处理
export function timestampToDate(timestamp) {
    var weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const date1 = new Date();
    var year1 = date1.getFullYear();
    var month1 = date1.getMonth() + 1; // 注意：月份是从0开始的，所以需要+1
    var day1 = date1.getDate();
    const date = new Date(timestamp);
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // 注意：月份是从0开始的，所以需要+1
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var dateString = "";
    if (year1 === year) {
        if (month1 === month) {
            if (day1 === day) {
                dateString = hours + ":" + (minutes >= 10 ? minutes : '0' + minutes);
                return dateString;
            }
            if (day1 - day === 1) {
                dateString = "昨天 "+hours + ":" + (minutes >= 10 ? minutes : '0' + minutes);
                return dateString;
            }
            if (day1 - day > 1 && day1 - day <= 7) {
                dateString = weekDays[date.getDay()] + ' ' + hours + ":" + (minutes >= 10 ? minutes : '0' + minutes);
                return dateString;
            }
            return month + '月' + day + "日 " + hours + ":" + (minutes >= 10 ? minutes : '0' + minutes);
        }
        return month + '月' + day + "日 " + hours + ":" + (minutes >= 10 ? minutes : '0' + minutes);
    }
    return year + '年' + month + '月' + day + "日";
}
export function timestampToDate1(timestamp) {
    var weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const date1 = new Date();
    var year1 = date1.getFullYear();
    var month1 = date1.getMonth() + 1; // 注意：月份是从0开始的，所以需要+1
    var day1 = date1.getDate();
    const date = new Date(timestamp);
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // 注意：月份是从0开始的，所以需要+1
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var dateString = "";
    if (year1 === year) {
        if (month1 === month) {
            if (day1 === day) {
                dateString = hours + ":" + (minutes >= 10 ? minutes : '0' + minutes);
                return dateString;
            }
            if (day1 - day === 1) {
                dateString = "昨天 ";
                return dateString;
            }
            if (day1 - day > 1 && day1 - day <= 7) {
                dateString = weekDays[date.getDay()] ;
                return dateString;
            }
            return month + '月' + day + "日 ";
        }
        return month + '月' + day + "日 ";
    }
    return year + '年' + month + '月' + day + "日";
}
// 消息类型处理
export function message(msg) {
    switch (msg.type) {
        case 'text':
            return msg;
        case 'custom':
            let content = JSON.parse(msg.content);
            switch (content.type) {
                case 14:
                    msg.text = content.data.value;
                    msg.type = 'text';
                    return msg;
                case 21:
                    msg.text = content.msg;

                    msg.type = 'text';
                    return msg;
                // case 24:
                //     msg.content = content;
                //     msg.custom = JSON.parse(msg.custom);
                //     msg.type = content.type;
                //     return msg;
                // case 8:
                //     msg.content = content;
                //     msg.type = content.type;
                //     return msg;
                // case 27:
                    //  请求后台接口获取职位详情
                   
                    // msg.content = content;
                    // msg.type = content.type;
                    // return msg;
                default:
                    msg.content = content;
                    msg.type = content.type;

                    return msg;
                    // return '未知消息类型请前往APP端查看';
            }
        // case "image":
        //     return msg;
        // case "audio":
        //     return msg;
        default:
            return msg;
    }
}


// WEBPACK FOOTER //
// ./src/utils/IM.js